// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ({"142":"chunk_statsgrid","264":"chunk_metrics"}[chunkId] + "/oskari.min.css");